import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LandingHero from "../../components/LandingHero/LandingHero";
import LandingLanguageSelect from "../../components/LandingLanguageSelect/LandingLanguageSelect";
import SignInSideCurtains from "../../components/SignInSideCurtains/SignInSideCurtains";
import SignUpSideCurtains from "../../components/SignUpSideCurtains/SignUpSideCurtains";
import AccountNotActiveModal from "../../common/LoginModal/AccountNotActiveModal";
import AuthContext from "../../store/auth-context";
import { state as signUpDefaultState } from "../../components/SignUpSideCurtains/SignUpSideCurtains.utils";
import { state as signInDefaultState } from "../../components/SignInSideCurtains/SignInSideCurtains.utils";
import { pageRootTestIds } from "../../testing/pageRootTestIds";

const LandingPage = () => {
  const authContext = useContext(AuthContext);
  const location = useLocation();
  const [cachedSignUpValues, setCachedSignUpValues] = useState({
    ...signUpDefaultState,
  });
  const [cachedSignInValues, setCachedSignInValues] = useState({
    ...signInDefaultState,
  });
  const [accountNotActiveMessage, setAccountNotActiveMessage] = useState("");
  const [showAccountNotActiveModal, setShowAccountNotActiveModal] =
    useState(false);

  useEffect(() => {
    const redirectFromGuard = location.state?.redirectAfterLogin;
    if (redirectFromGuard) {
      localStorage.setItem("redirectAfterLogin", redirectFromGuard);
    }

    authContext.setTriggerLoginModuleToggleValue(false);
    authContext.chooseSignUp_SignIn(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleAuthMode = () => {
    authContext.chooseSignUp_SignIn(!authContext.signOrSignUp);
  };

  const clearSignUpCache = () => {
    setCachedSignUpValues({ ...signUpDefaultState });
  };

  const clearSignInCache = () => {
    setCachedSignInValues({ ...signInDefaultState });
  };

  const handleAccountNotActive = (message) => {
    setAccountNotActiveMessage(message || "");
    setShowAccountNotActiveModal(true);
  };

  const closeAccountNotActiveModal = () => {
    setShowAccountNotActiveModal(false);
    setAccountNotActiveMessage("");
  };

  return (
    <div
      id={pageRootTestIds.landing}
      className="flex h-screen max-h-screen overflow-hidden flex-col bg-white font-CfPrimaryFont lg:flex-row"
    >
      <AccountNotActiveModal
        isOpen={showAccountNotActiveModal}
        message={accountNotActiveMessage}
        onClose={closeAccountNotActiveModal}
      />
      <LandingHero />

      <section className="flex h-screen w-full flex-col bg-white lg:max-w-[534px] lg:shrink-0">
        <div className="flex flex-1 justify-center overflow-y-auto px-6 py-8 sm:px-12">
          <div className="w-full max-w-[419px]">
            <div className="mb-6 flex justify-end">
              <LandingLanguageSelect />
            </div>

            {authContext.signOrSignUp ? (
              <SignInSideCurtains
                variant="landing"
                closeModal={() => {}}
                onAccountNotActive={handleAccountNotActive}
                toggleComponent={toggleAuthMode}
                cachedValues={cachedSignInValues}
                setCachedValues={setCachedSignInValues}
                clearCache={clearSignInCache}
              />
            ) : (
              <SignUpSideCurtains
                variant="landing"
                closeModal={() => {}}
                toggleComponent={toggleAuthMode}
                toggleIsMessage={() => {}}
                cachedValues={cachedSignUpValues}
                setCachedValues={setCachedSignUpValues}
                clearCache={clearSignUpCache}
              />
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
